module.exports = __webpack_public_path__ + "static/take_photos_videos-3f4f26388cc0428bd8ba2a036ff5cb58.gif";